import { Action } from '@ngrx/store';
import { WorkCenterDto } from '@app/generated/model';

export enum WorkCenterActionTypes {
  LoadWorkCenters = '[WorkCenter] Load WorkCenters',
  LoadWorkCentersSuccess = '[WorkCenter] Load WorkCenters Success',
  AddWorkCenter = '[WorkCenter] Add WorkCenter',
  AddWorkCenterSuccess = '[WorkCenter] Add WorkCenter Success',
  UpdateWorkCenter = '[WorkCenter] Update WorkCenter',
  UpdateWorkCenterSuccess = '[WorkCenter] Update WorkCenter Success',
  FilterWorkCenters = '[WorkCenter] Filter WorkCenters',
}

export class LoadWorkCenters implements Action {
  readonly type = WorkCenterActionTypes.LoadWorkCenters;
  constructor(public siteId: string) {}
}

export class LoadWorkCentersSuccess implements Action {
  readonly type = WorkCenterActionTypes.LoadWorkCentersSuccess;
  constructor(public workCenters: WorkCenterDto[]) {}
}

export class AddWorkCenter implements Action {
  readonly type = WorkCenterActionTypes.AddWorkCenter;
  constructor(
    public siteId: string,
    public workCenter: WorkCenterDto,
  ) {}
}

export class AddWorkCenterSuccess implements Action {
  readonly type = WorkCenterActionTypes.AddWorkCenterSuccess;
  constructor(public workCenter: WorkCenterDto) {}
}

export class UpdateWorkCenter implements Action {
  readonly type = WorkCenterActionTypes.UpdateWorkCenter;
  constructor(
    public siteId: string,
    public workCenterId: string,
    public workCenter: WorkCenterDto,
  ) {}
}

export class UpdateWorkCenterSuccess implements Action {
  readonly type = WorkCenterActionTypes.UpdateWorkCenterSuccess;
  constructor(public workCenter: WorkCenterDto) {}
}

export class FilterWorkCenters implements Action {
  readonly type = WorkCenterActionTypes.FilterWorkCenters;
  constructor(public filter: string) {}
}

export type WorkCenterActions =
  | LoadWorkCenters
  | LoadWorkCentersSuccess
  | AddWorkCenter
  | AddWorkCenterSuccess
  | UpdateWorkCenter
  | UpdateWorkCenterSuccess
  | FilterWorkCenters;
